module.exports = __webpack_public_path__ + "static/displacer_kitten-eadf29425f4a0dbe1b7ba8812f8c1b48.jpg";